import { useEffect, useRef, useState } from "react";
import { animate, motion, useInView } from "framer-motion";

function Stat({ value, decimals = 0, prefix = "", suffix = "", label, testid, delay = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      delay,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) =>
        setDisplay(decimals > 0 ? v.toFixed(decimals) : Math.round(v).toLocaleString("en-US")),
    });
    return () => controls.stop();
  }, [inView, value, decimals, delay]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testid}
      className="relative border-l border-white/10 pl-6"
    >
      <div className="font-display text-4xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">
        {prefix}
        {display}
        <span className="text-forge">{suffix}</span>
      </div>
      <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400">{label}</div>
    </motion.div>
  );
}

export default function StatsSection() {
  return (
    <section data-testid="stats-section" className="border-y border-white/[0.07] bg-navy-900/40 py-16 sm:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
        <Stat testid="stat-homes-served" value={15000} suffix="+" label="Homes Served" />
        <Stat testid="stat-rating" value={4.9} decimals={1} suffix="/5" label="Average Rating" delay={0.1} />
        <Stat testid="stat-dispatch-time" value={22} suffix=" yrs" label="Serving the Metro" delay={0.2} />
        <Stat testid="stat-warranty" value={100} suffix="%" label="Parts & Labor Warrantied" delay={0.3} />
      </div>
    </section>
  );
}
